import { render } from "./SiteHeadingInner.vue?vue&type=template&id=59b77540"
import script from "./SiteHeadingInner.vue?vue&type=script&lang=js"
export * from "./SiteHeadingInner.vue?vue&type=script&lang=js"

import "./SiteHeadingInner.vue?vue&type=style&index=0&id=59b77540&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__